var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button } from '@honeycomb/ui-core';
import { useGlobalContext, TripType, useSearch } from '@honeycomb/data';
import { searchCreatedRouting } from '@honeycomb/routing';
export function LookForHotelOnlyButton(_a) {
    var other = __rest(_a, []);
    const [searchparameters, setSearch] = useSearch([searchCreatedRouting]);
    const { createSearch } = setSearch;
    const { resourceStrings: { LOOK_HOTEL_ONLY }, } = useGlobalContext();
    return (React.createElement(Button, Object.assign({ size: "l", color: "primary", variant: "outlined", "data-id": "look-hotel-only", onClick: () => {
            createSearch(Object.assign(Object.assign({}, searchparameters), { tripType: TripType.Hotel }));
        } }, other), LOOK_HOTEL_ONLY));
}
